"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _moment = _interopRequireDefault(require("moment"));
require("moment/locale/de");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _appContext = _interopRequireDefault(require("../../context/appContext"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  list: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: theme.spacing(1.5)
  },
  box: {
    margin: theme.spacing(0, 0, 1)
  },
  state: {
    fontWeight: theme.typography.fontWeightBold
  },
  stateOpened: {
    color: theme.palette.success.dark
  },
  stateClosed: {
    color: theme.palette.error.dark
  },
  days: {
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(1, 0, 1)
  },
  day: {
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(0, 0, 0.5)
  },
  weekDay: {
    fontWeight: theme.typography.fontWeightBold
  },
  times: {}
}));
const OpeningDates = () => {
  const [appData] = (0, _react.useContext)(_appContext.default);
  const css = useStyles();
  const openingDates = appData === null || appData === void 0 ? void 0 : appData.openingSchedules;
  if (!(0, _lodash.isEmpty)(openingDates)) {
    const list = openingDates.map((item, counter) => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: css.box,
        key: counter
      }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        component: "div"
      }, (0, _moment.default)(new Date(item.from)).format("L"), " - ", (0, _moment.default)(new Date(item.to)).format("L")), /*#__PURE__*/_react.default.createElement(_core.Typography, {
        component: "div"
      }, "An folgenden Tagen", " ", /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(css.state, " ").concat(item.state === "open" ? css.stateOpened : css.stateClosed)
      }, item.state === "open" ? "geöffnet" : "geschlossen", ":")), /*#__PURE__*/_react.default.createElement(_core.Box, {
        className: css.days
      }, item.days.map((day, subCounter) => {
        return /*#__PURE__*/_react.default.createElement(_core.Box, {
          className: css.day,
          key: counter * 1000 + subCounter
        }, /*#__PURE__*/_react.default.createElement(_core.Box, {
          className: css.weekDay
        }, getWeekday(day.day)), /*#__PURE__*/_react.default.createElement(_core.Box, {
          className: css.times
        }, day.times ? day.times.map((time, timeCounter) => {
          return /*#__PURE__*/_react.default.createElement("span", {
            key: counter * 1000 + timeCounter
          }, timeCounter > 0 ? ", " : null, formatTime(time.from), " - ", formatTime(time.to));
        }) : ""));
      })));
    });
    return /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "subtitle1"
    }, "\xD6ffnungszeiten"), /*#__PURE__*/_react.default.createElement(_core.Box, {
      className: css.list
    }, list));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
function getWeekday(weekDay) {
  switch (weekDay) {
    case 1:
      return "Montag";
    case 2:
      return "Dienstag";
    case 3:
      return "Mittwoch";
    case 4:
      return "Donnerstag";
    case 5:
      return "Freitag";
    case 6:
      return "Samstag";
    case 0:
      return "Sonntag";
    default:
      return "";
  }
}
function formatTime(time) {
  return time.split(":").slice(0, -1).join(":");
}
var _default = exports.default = OpeningDates;